import { render, staticRenderFns } from "./ServerAlert.vue?vue&type=template&id=09553378&scoped=true&lang=pug&"
import script from "./ServerAlert.vue?vue&type=script&lang=js&"
export * from "./ServerAlert.vue?vue&type=script&lang=js&"
import style0 from "./ServerAlert.vue?vue&type=style&index=0&id=09553378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09553378",
  null
  
)

export default component.exports